<div class="user-selection-list">
  <div
    class="user-selection-list__row"
    *ngFor="let user of users; trackBy: trackByUserId"
  >
    <label
      nz-checkbox
      class="user-selection-list__checkbox"
      [nzChecked]="isSelected(user.id)"
      (nzCheckedChange)="onToggle(user.id, $event)"
      [nzDisabled]="disabled"
    >
      <div class="user-selection-list__content">
        <div class="user-selection-list__primary">
          {{ user.primaryText }}
        </div>
        <div
          class="user-selection-list__secondary"
          *ngIf="user.secondaryText"
        >
          {{ user.secondaryText }}
        </div>
        <div
          class="user-selection-list__meta"
          *ngIf="user.meta?.length"
        >
          <ng-container *ngFor="let metaItem of user.meta; let i = index">
            <span
              class="user-selection-list__meta-item"
              *ngIf="metaItem"
            >
              <span
                class="user-selection-list__meta-separator"
                *ngIf="i > 0"
                >•</span
              >
              {{ metaItem }}
            </span>
          </ng-container>
        </div>
      </div>
    </label>
  </div>
</div>
